import React, { type ChangeEvent, useMemo } from "react";
import { Field, type FormikErrors } from "formik";
import { Config, TokenHistoryLabel, type Cta } from "kadow-jetpack-model";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkSquare } from "@fortawesome/free-solid-svg-icons";
import { tt } from "../../../../../utils/i18n/i18n";
import KC_Span from "../../../../../designsystem/KC_Span/KC_Span";
import KC_Colors from "../../../../../designsystem/KC_Colors";
import DownloadAppLinkFields from "./DownloadAppLinkFields";

interface CTALinkFieldsProps {
  idx: number;
  cta: Cta;
  setFieldValue: (field: string, value: any) => void;
  errors: FormikErrors<Config>;
  config: Config;
}

const CTALinkFields: React.FC<CTALinkFieldsProps> = (props) => {
  const goToLink = (link: string) => {
    window.open(link, "_blank", "noopener,noreferrer");
  };

  const setFieldValue = (val: string) => {
    let formattedLink = val.trim();

    if (formattedLink.startsWith("http://")) {
      formattedLink = formattedLink.replace("http://", "https://");
    }

    if (!formattedLink.startsWith("https://")) {
      formattedLink = `https://${formattedLink}`;
    }

    props.setFieldValue(`ctas.${props.idx}.customAction`, formattedLink);
  };

  const error = useMemo(() => {
    // @ts-ignore
    return props.errors?.ctas?.[props.idx]?.customAction;
  }, [props.errors, props.idx]);

  const placeholder = useMemo(() => {
    switch (props.cta.id) {
      case TokenHistoryLabel.TripAdvisor:
        return tt("cta_link_fields_placeholder_tripadvisor");
      case TokenHistoryLabel.WhatsappGroup:
        return tt("cta_card_whatsapp_group_link_placeholder");
      default:
        return tt("cta_link_fields_placeholder");
    }
  }, [props.cta.id]);

  const isDownloadApp = props.cta.id === TokenHistoryLabel.DownloadApp;

  if (isDownloadApp) {
    return (
      <DownloadAppLinkFields
        idx={props.idx}
        setFieldValue={props.setFieldValue}
        errors={props.errors}
        config={props.config}
      />
    );
  }

  return (
    <>
      <div className="kc-input-wrapper">
        <Field
          id={`input-${props.cta.id}`}
          className="form-control kc_input"
          type="text"
          name={`ctas.${props.idx}.customAction`}
          placeholder={placeholder}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            setFieldValue(e.target.value);
          }}
          required={true}
        />
        <div className="input-group-append p-2 border-left h-100 cursor-pointer">
          <div
            onClick={() => {
              goToLink(props.cta.customAction || "");
            }}
          >
            <FontAwesomeIcon
              icon={faExternalLinkSquare}
              color={"#FF2C81"}
              size={"lg"}
            />
          </div>
        </div>
      </div>

      {!!error && (
        <KC_Span
          id={"error"}
          className="error"
          text={error}
          color={KC_Colors.Error}
        />
      )}
    </>
  );
};

export default CTALinkFields;
